import React from "react";

const Logo = () => {
  const APP_PATH = process.env.REACT_APP_CONTEXT_PATH;
  return (
    <div className="main-logo">
      <img
        alt="SUPPLY CHAIN TWIN LOGO"
        src={`${APP_PATH}/splash-logo.svg`}
        width="280px"
      />
    </div>
  );
};

export default Logo;
